"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const InputField_1 = require("./InputField");
require("./LocationInput.scss");
const LocationInput_scss_json_1 = __importDefault(require("./LocationInput.scss.json"));
const AdministrativeArea_1 = require("lincd-schema/lib/shapes/AdministrativeArea");
const Hooks_1 = require("lincd/lib/utils/Hooks");
const PlacePreview_1 = require("./PlacePreview");
const react_2 = require("@tolgee/react");
const PostalAddress_1 = require("lincd-schema/lib/shapes/PostalAddress");
const OPENSTREETMAP_API = 'https://nominatim.openstreetmap.org/search';
const LocationInput = ({ of, property, multiple, maxCount, saveLocation = true, onPlaceSelect, onCallback, onRemoveLocation, onSearching, }) => {
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const [debounceSearch, setDebounceSearch] = (0, react_1.useState)('');
    const [results, setResults] = (0, react_1.useState)([]);
    const [showResults, setShowResults] = (0, react_1.useState)(false);
    const [selectedPlace, setSelectedPlace] = (0, react_1.useState)();
    const [isSearching, setIsSearching] = (0, react_1.useState)(false);
    // disable API if the API is not reachable
    const [isApiDisabled, setIsApiDisabled] = (0, react_1.useState)(false);
    let listRef = (0, react_1.useRef)(null);
    let inputRef = (0, react_1.useRef)(null);
    const [showNewLocationInput, setShowNewLocationInput] = (0, react_1.useState)(true);
    const { t } = (0, react_2.useTranslate)();
    const prefix = 'location';
    let currentValue;
    let currentValues;
    if (multiple) {
        currentValues = of[property];
    }
    else {
        currentValue = of[property];
    }
    //temporary trick to force update based on changed internal graph state
    (0, Hooks_1.useWatchProperty)(of, property);
    const onClickWindow = (e) => {
        //if the user did not click on the list or the inputfield, close the list of results
        if ((!listRef.current || !listRef.current.contains(e.target)) &&
            inputRef.current &&
            !inputRef.current.contains(e.target)) {
            setShowResults(false);
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('click', onClickWindow);
        return () => {
            window.removeEventListener('click', onClickWindow);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        // add debounce time for delaying users typing for better performances
        const timeout = setTimeout(() => {
            setDebounceSearch(searchTerm);
        }, 800);
        return () => {
            clearTimeout(timeout);
        };
    }, [searchTerm]);
    // store the onSearching status to the parent component
    // for use cases like showing a loading spinner when searching processin progress
    (0, react_1.useEffect)(() => {
        if (onSearching) {
            onSearching(isSearching);
        }
    }, [isSearching, onSearching]);
    (0, react_1.useEffect)(() => {
        // fetch the Open Street Map API
        const fetchResults = () => __awaiter(void 0, void 0, void 0, function* () {
            if (debounceSearch.length >= 3 && !isApiDisabled) {
                // set searching state to true when user starts typing
                setIsSearching(true);
                // start measuring time
                const startTime = performance.now();
                try {
                    const response = yield fetch(`${OPENSTREETMAP_API}?q=${debounceSearch}&addressdetails=1&format=json`);
                    if (!response.ok) {
                        // if the API is not reachable, set the API to disabled
                        throw new Error(`Failed to search location`);
                    }
                    // measure the time taken for the API response
                    const endTime = performance.now();
                    const responseTime = endTime - startTime;
                    // check if the response time is more than 5 seconds
                    if (responseTime > 5000) {
                        setIsApiDisabled(true);
                        setResults([]);
                        console.log(`API response time exceeded 2 seconds: ${results}`);
                        return;
                    }
                    const data = yield response.json();
                    setResults(data);
                }
                catch (err) {
                    console.error(`Error fetching location: ${err}`);
                    setIsApiDisabled(true);
                }
                finally {
                    setIsSearching(false);
                }
            }
            else {
                setResults([]);
            }
        });
        // if the user is editing, it will fetch the search results from the OpenStreetMap API
        if (showResults) {
            fetchResults();
        }
    }, [debounceSearch, showResults, isApiDisabled]);
    const handleSelect = (0, react_1.useCallback)((result) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { display_name, lat, lon, osm_id, osm_type, class: class_type, address, } = result;
        const city = address.city ||
            address.town ||
            address.village ||
            address.hamlet ||
            address.county;
        const region = address.state || address.region;
        const country = address.country || address.country_code;
        const countryCode = address.country_code;
        // show alert if there is no city, region or country
        if (!city) {
            alert(t(prefix + '.noCityAlert', `It looks like you selected a region or country. Please enter a valid city name.`));
            return;
        }
        const newPostalAddress = new PostalAddress_1.PostalAddress();
        newPostalAddress.postalCode = ((_a = address === null || address === void 0 ? void 0 : address.postcode) === null || _a === void 0 ? void 0 : _a.toString()) || '';
        newPostalAddress.addressLocality = city;
        if (region) {
            newPostalAddress.addressRegion = region;
        }
        newPostalAddress.addressCountry = country;
        newPostalAddress.identifier = countryCode;
        // Create a new areaServed with the selected values
        // Person.address.areaServed = newAreaServed;
        const newAreaServed = AdministrativeArea_1.AdministrativeArea.getFromURI(`${process.env.DATA_ROOT}/area-served/${osm_id.toString()}`);
        newAreaServed.identifier = osm_id.toString();
        newAreaServed.name = display_name;
        newAreaServed.latitude = lat;
        newAreaServed.longitude = lon;
        newAreaServed.additionalType = osm_type;
        newAreaServed.disambiguatingDescription = class_type;
        if (saveLocation) {
            setSelectedPlace(newPostalAddress);
            // save new AreaServed
            newAreaServed.save();
            // set the new areaServed to the address
            newPostalAddress.areaServed = newAreaServed;
            newPostalAddress.save();
            if (onCallback) {
                onCallback(newAreaServed.name);
            }
            // Update the property value by adding a value or overwriting the value
            if (multiple) {
                currentValues === null || currentValues === void 0 ? void 0 : currentValues.add(newPostalAddress);
            }
            else {
                of[property] = newPostalAddress;
            }
        }
        else {
            // If saveLocation is false, don't save the place, just update the displayed value
            setSearchTerm(display_name);
            // Update the property value without saving the place
            if (saveLocation) {
                if (multiple) {
                    // Clear previous values if saveLocation is false
                    currentValues === null || currentValues === void 0 ? void 0 : currentValues.clear();
                    // Add the new place
                    currentValues === null || currentValues === void 0 ? void 0 : currentValues.add(newPostalAddress);
                }
                else {
                    of[property] = newPostalAddress;
                }
            }
            // Pass the selected place to the parent component
            if (onPlaceSelect) {
                onPlaceSelect(newPostalAddress);
            }
            // Clear previous search results
            setResults([]);
        }
    }), [saveLocation]);
    const handleRemoveLocation = (place) => {
        if (multiple) {
            currentValues === null || currentValues === void 0 ? void 0 : currentValues.delete(place);
        }
        else {
            of[property] = null;
            place.remove();
            setSearchTerm('');
        }
        // pass the removed place to the parent component
        if (onRemoveLocation) {
            onRemoveLocation(place);
        }
    };
    // set value from input field and show results
    const handleSearchTermChange = (0, react_1.useCallback)((event) => {
        const val = event.target.value;
        setSearchTerm(val);
        setShowResults(true);
        if (onCallback) {
            onCallback(val);
        }
    }, [isApiDisabled]);
    // if the API is disabled, we need to save the value from the input field to database
    const handleSaveLocation = () => {
        if (isApiDisabled) {
            setResults([]);
            setShowResults(false);
            // save value to the database
            const newAreaServed = AdministrativeArea_1.AdministrativeArea.getFromURI(`${process.env.DATA_ROOT}/area-served/${slugify(searchTerm)}`);
            newAreaServed.name = searchTerm;
            newAreaServed.identifier = slugify(searchTerm);
            newAreaServed.save();
            const newPostalAddress = new PostalAddress_1.PostalAddress();
            newPostalAddress.areaServed = newAreaServed;
            newPostalAddress.save();
            if (saveLocation) {
                setSelectedPlace(newPostalAddress);
                // Save place only if saveLocation is true
                newAreaServed.save();
                // Update the property value by adding a value or overwriting the value
                if (multiple) {
                    currentValues === null || currentValues === void 0 ? void 0 : currentValues.add(newPostalAddress);
                }
                else {
                    of[property] = newPostalAddress;
                }
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        multiple &&
            (currentValues === null || currentValues === void 0 ? void 0 : currentValues.map((location) => (react_1.default.createElement(PlacePreview_1.PostalAddressPreview, { key: location.toString(), of: location, onRemove: handleRemoveLocation })))),
        !multiple && (react_1.default.createElement(react_1.default.Fragment, null, saveLocation && currentValue && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.areaServed) ? (react_1.default.createElement(PlacePreview_1.PostalAddressPreview, { key: currentValue === null || currentValue === void 0 ? void 0 : currentValue.toString(), of: currentValue, onRemove: handleRemoveLocation })) : (react_1.default.createElement("div", { ref: inputRef },
            react_1.default.createElement(InputField_1.InputField, { placeholder: isApiDisabled
                    ? t(prefix + '.inputLocation', 'Please enter your city')
                    : t(prefix + '.searchLocation', 'Please select your city in the drop-down options'), value: searchTerm, onChange: handleSearchTermChange, onBlur: handleSaveLocation }),
            showResults && (react_1.default.createElement("div", { className: LocationInput_scss_json_1.default.locationResult, ref: listRef },
                react_1.default.createElement("ul", null,
                    isSearching && (react_1.default.createElement("li", { className: LocationInput_scss_json_1.default.listItem },
                        react_1.default.createElement("p", null, t(prefix + '.searching', 'Searching Cities...')))),
                    !isSearching &&
                        !isApiDisabled &&
                        results.slice(0, 5).map((result) => (react_1.default.createElement("li", { key: result.place_id, className: LocationInput_scss_json_1.default.listItem, onClick: () => handleSelect(result) },
                            react_1.default.createElement("p", null, result.display_name)))))))))))));
};
exports.default = LocationInput;
/**
 * helper function to slugify a string
 *
 * @example
 * slugify('Hello World') // hello-world
 * slugify('Hello World!') // hello-world
 * slugify('Hello World! 123') // hello-world-123
 * slugify('Hello World! 123') // hello-world-123
 *
 * @param text
 * @returns
 */
function slugify(text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove all special characters
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/-+/g, '-') // Replace multiple - with single -
        .replace(/^-+|-+$/g, ''); // Trim - from start and end
}
//# sourceMappingURL=LocationInput.js.map